/* eslint-disable import/prefer-default-export */
export const idToNameParserMixin = {
  methods: {
    /**
     * Based on the id passed in, returns the name from the array in which the object should exist
     * @param {String} value - Id or shortcode of entity
     * @param {Array} array - Array of values to look in
     */
    idToName(value, array) {
      if (!value) return '-';
      if (!array) return 'Unknown';
      // find!
      let rv = array.find(v => v.id == value);
      if (!rv) {
        rv = array.find(v => v.shortcode == value)
      }
      return rv ? rv.name : 'Unknown';
    }
  }
}
